export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/booking-call-icon.8a2ab878.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};